export const NUM_TRIES = 6;
export const NUM_LETTERS = 5;
export const LIMIT = NUM_TRIES * NUM_LETTERS;

export const STATUS_COLORS: Record<BoxStatus, string> = {
  actual: "#12c512",
  include: "#e7b707",
  exclude: "#b7b7b7",
  unknown: "#ffffff",
};
